import { OrdersListPage } from './OrdersListPage';
export function OrdersB2cPage() { return <OrdersListPage orderType="B2C" />; }
